<table>
    @if ($sourceInfo()) {
        <tr>
            <td>{{ "Source" }}</td>
            <td>{{ $sourceInfo() }}</td>
        </tr>
    }
    <tr>
        <td>Workflow</td>
        <td>{{ workflowToString($exportSummary().workflow) }}</td>
    </tr>
    <tr>
        <td>Engine</td>
        <td>{{ engineToString($exportSummary().engine) }}</td>
    </tr>
    <tr>
        <td>Normal</td>
        <td>{{ normalYToString($exportSummary().normalY) }}</td>
    </tr>
    <tr>
        <td>Format</td>
        <td>{{ $exportSummary().format | uppercase }}</td>
    </tr>
    <tr>
        <td>Resolution</td>
        <td>{{ resolutionToString($exportSummary().resolution) }}</td>
    </tr>
</table>
